/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH2Icon16Solid = forwardRef('SettingsSlidersH2Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 6h5.437a2.751 2.751 0 0 0 5.125 0H14a1 1 0 1 0 0-2h-1.438a2.75 2.75 0 0 0-5.125 0H2a1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M2 10a1 1 0 1 0 0 2h1.437a2.751 2.751 0 0 0 5.126 0H14a1 1 0 1 0 0-2H8.563a2.751 2.751 0 0 0-5.126 0H2Z" })));
});
